import { createAction, props } from '@ngrx/store';
import { RequestCurrencyType, ResponseCurrencyType } from '../../shared/interfaces';
import { currencyTypeTypes } from '../../shared/enums';

export const getcurrencyType = createAction(
    currencyTypeTypes.CONFIG_REQUEST_MANAGER,
    props<{ request: RequestCurrencyType}>()
);

export const getcurrencyTypeSucess = createAction(
    currencyTypeTypes.CONFIG_REQUEST_MANAGER_SUCCESS,
    props<{ response: ResponseCurrencyType }>()
);

export const getcurrencyTypeError = createAction(
    currencyTypeTypes.CONFIG_REQUEST_MANAGER_ERROR,
    props<{ payload: any }>()
);

export const cleanState = createAction(
    currencyTypeTypes.CLEAN_STATE
);

